import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { UserService } from 'app/_core/services/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthProfileGuard {
  constructor(private readonly userService: UserService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return !this.userService.getUser().isInternal;
  }
}
